<template>
  <BreadCrumb PageTitle="Account Settings" />
  <CoverImage />
  <StatuSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import CoverImage from "../../components/Generals/CoverImage.vue";
import StatuSettings from "../../components/Generals/AccountSettings/StatuSettings.vue";

export default defineComponent({
  name: "StatuSettingsPage",
  components: {
    BreadCrumb,
    CoverImage,
    StatuSettings,
  },
});
</script>